import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const BroadcastStatusKeys = new Set([
  'broadcasts.status',
  'broadcasts_recurring_settings.status',
])

export const isBroadcastStatusWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  BroadcastStatusKeys.has(filterItem.key)
